declare namespace $ {

	type $mol_string_button__value_shm_service_dashboard_1 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard['task_title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $shm_service_mode_controls__edit_shm_service_dashboard_2 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard['edit'] >
		,
		ReturnType< $shm_service_mode_controls['edit'] >
	>
	type $shm_service_mode_controls__view_shm_service_dashboard_3 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard['view'] >
		,
		ReturnType< $shm_service_mode_controls['view'] >
	>
	type $shm_service_mode_controls__view_enabled_shm_service_dashboard_4 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard['view_enabled'] >
		,
		ReturnType< $shm_service_mode_controls['view_enabled'] >
	>
	type $shm_service_mode_controls__edit_color_shm_service_dashboard_5 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard['edit_color'] >
		,
		ReturnType< $shm_service_mode_controls['edit_color'] >
	>
	type $shm_service_mode_controls__view_color_shm_service_dashboard_6 = $mol_type_enforce<
		ReturnType< $shm_service_dashboard['view_color'] >
		,
		ReturnType< $shm_service_mode_controls['view_color'] >
	>
	export class $shm_service_dashboard extends $shm_service_workspace {
		task_title( next?: string ): string
		edit( next?: any ): any
		view( next?: any ): any
		edit_color( ): string
		view_color( ): string
		service_id( ): string
		task_id( ): string
		mode( ): string
		view_enabled( ): boolean
		Title( ): $mol_string_button
		Mode( ): $shm_service_mode_controls
		Menu( ): $shm_service_task_menu
	}
	
}

//# sourceMappingURL=dashboard.view.tree.d.ts.map